var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 23,
    height: 23,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9855 4.80905H17.407V3.06678C17.407 2.96087 17.3211 2.875 17.2152 2.875H16.1601C16.0542 2.875 15.9683 2.96087 15.9683 3.06678V4.80905H8.53171V3.06678C8.53171 2.96087 8.44582 2.875 8.33987 2.875H7.2848C7.17884 2.875 7.09296 2.96087 7.09296 3.06678V4.80905H5.51453C4.48156 4.80905 3.64417 5.64618 3.64417 6.67882V8.74441C3.64417 9.37988 4.15948 9.89504 4.79516 9.89504H17.4874C18.1231 9.89504 18.6384 9.37988 18.6384 8.74441V8.64854C18.6384 8.54262 18.5525 8.45676 18.4465 8.45676H5.51453C5.27615 8.45676 5.08291 8.26358 5.08291 8.02528V6.67882C5.08291 6.44052 5.27615 6.24734 5.51453 6.24734H7.09296V6.73162C7.09296 6.83754 7.17884 6.92339 7.2848 6.92339H8.33987C8.44582 6.92339 8.53171 6.83754 8.53171 6.73162V6.24734H15.9683V6.73162C15.9683 6.83754 16.0542 6.92339 16.1601 6.92339H17.2152C17.3211 6.92339 17.407 6.83754 17.407 6.73162V6.24734H18.9855C19.2238 6.24734 19.4171 6.44052 19.4171 6.67882V18.2553C19.4171 18.4936 19.2238 18.6867 18.9855 18.6867H5.51453C5.27615 18.6867 5.08291 18.4936 5.08291 18.2553V12.0958C5.08291 11.4603 4.5676 10.9451 3.93191 10.9451H3.83599C3.73005 10.9451 3.64417 11.031 3.64417 11.1369V18.2553C3.64417 19.2879 4.48156 20.125 5.51453 20.125H18.9855C20.0184 20.125 20.8558 19.2879 20.8558 18.2553V6.67882C20.8558 5.64618 20.0184 4.80905 18.9855 4.80905Z",
    fill: "#006564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.72576ad3a85e06039e3ca4caad1e0410.svg";
export { ForwardRef as ReactComponent };